var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"login-home"}},[_c('v-main',[_c('div',{staticStyle:{"width":"100vw","height":"100vh","display":"flex","justify-content":"center","align-items":"center"}},[_vm._v(" Autenticando Usuario... "+_vm._s(_vm.idusuario)+" ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }